// This is where your filter form will be configured

import { UsageTransfer } from '@qsightpbi-integration/sdk';
import { number, object } from 'yup';
import { IQueryBuilderSelects } from '../shared/Forms/FilterForm/filterFormSetup';
import { InferType } from 'yup';

// Define your filter form validation schema here
// This should only account for the non-standard inputs 
const schema = object({
    // Optional: do not require expiringBucket; treat empty string as undefined
    expiringBucket: number()
        .transform((val, orig) => (orig === '' || orig === null ? undefined : val))
        .nullable()
        .optional(),
    consigned: number().nullable(),
});

export type FormType = InferType<typeof schema>;
export type FormValues = FormType & {
    [key: string]: any // this is necessary because of the transformation around consignment
};

// Define your formInputs here
const formInputs = [
    { label: 'Hospital Name', type: 'checkbox', placeholder: 'Hospital Name', name: 'hospitalName' as keyof UsageTransfer.Props, options: [] },
    {
        label: 'Hospital Group Name', type: 'checkbox', placeholder: 'Hospital Group Name', name: 'hospitalGroupName' as keyof UsageTransfer.Props, options: [
            { value: 'group1', label: 'Group 1' },
            { value: 'group2', label: 'Group 2' },
            { value: 'group3', label: 'Group 3' },
        ]
    },
    {
        label: 'Department Name', type: 'checkbox', placeholder: 'Department Name', name: 'holderId' as keyof UsageTransfer.Props, options: [
            { value: 'dept1', label: 'Department 1' },
            { value: 'dept2', label: 'Department 2' },
            { value: 'dept3', label: 'Department 3' },
        ]
    }
];

// Define your default values here
const defaultValues = {};


// Define your onError function here
const onError = (errors: any, e: any) => {
    // Handle form submission errors
    console.error('Form submission error:', errors, e);
};

// Define your loading state here
// const loading = false; // Define your loading state here


const reportObjectFields: IQueryBuilderSelects = {
    name: 'fieldName',
    data: [
        {
            label: 'Brand Name',
            value: 'productBrandName',
            type: 'string',
        },
        {
            label: 'Catalog No',
            value: 'catalogNo',
            type: 'string',
        },
        {
            label: 'Description',
            value: 'productDescription',
            type: 'string',
        },
    
        {
            label: 'Manufacturer Name',
            value: 'manufacturerName',
            type: 'string',
        },
        {
            label: 'Par',
            value: 'parLevel',
            type: 'number',
        },
        {
            label: 'Price',
            value: 'currentPriceEach',
            type: 'number',
        },
    ]
};

export { schema, formInputs, defaultValues, onError, reportObjectFields };
